/**
 * AccessibilityPlanner.config.js
 *
 * Static configuration for the Accessibility Planner tool.
 * Controls copy, assessment sections, and category-specific behavior.
 */

const AccessibilityPlannerConfig = {
  id: "accessibilityPlanner",

  title: "Home Accessibility & Safety Planner",

  description:
    "Answer a few questions to see how well your home supports mobility, safety, and aging in place.",

  ctaLabel: "View My Accessibility Summary",

  /**
   * Default responses
   */
  defaults: {},

  /**
   * Assessment sections
   */
  sections: [
    {
      id: "mobility",
      title: "Mobility & Movement",
      questions: [
        {
          id: "stairsDifficulty",
          label: "Does anyone in the home have difficulty using stairs?",
          options: [
            { value: "no", label: "No difficulty" },
            { value: "some", label: "Some difficulty" },
            { value: "significant", label: "Significant difficulty" },
          ],
        },
        {
          id: "balance",
          label: "Are balance or stability issues a concern?",
          options: [
            { value: "no", label: "No" },
            { value: "occasional", label: "Occasionally" },
            { value: "frequent", label: "Frequently" },
          ],
        },
      ],
    },

    {
      id: "bathroom",
      title: "Bathroom Safety",
      questions: [
        {
          id: "slipRisk",
          label: "Is there a risk of slipping in the bathroom?",
          options: [
            { value: "no", label: "No" },
            { value: "unsure", label: "Not sure" },
            { value: "yes", label: "Yes" },
          ],
        },
        {
          id: "tubAccess",
          label: "Is getting in and out of the tub or shower difficult?",
          options: [
            { value: "no", label: "No difficulty" },
            { value: "some", label: "Some difficulty" },
            { value: "yes", label: "Yes, very difficult" },
          ],
        },
      ],
    },

    {
      id: "entryways",
      title: "Entrances & Pathways",
      questions: [
        {
          id: "entrySteps",
          label: "Are there steps required to enter the home?",
          options: [
            { value: "no", label: "No steps" },
            { value: "few", label: "One or two steps" },
            { value: "many", label: "Multiple steps" },
          ],
        },
        {
          id: "doorWidth",
          label: "Are doorways wide enough for mobility aids?",
          options: [
            { value: "yes", label: "Yes" },
            { value: "unsure", label: "Not sure" },
            { value: "no", label: "No" },
          ],
        },
      ],
    },
  ],

  /**
   * Result copy
   */
  result: {
    title: "Accessibility Summary",
    disclaimer:
      "This assessment is informational only and does not replace a professional home evaluation.",
  },
};

export default AccessibilityPlannerConfig;
